/**
 * Automatisk tilldelning (#1653): an issue's state against the förvaltare's
 * judgement, derived from the issue and `global/autoAssignment/issues`.
 * Nothing of it is stored except the decision (`costAssessment`).
 */
import { Issue } from '../types/issues';
import { IssueAutoAssignment } from '../types/autoAssignment';

export type IssueAssessmentState = 'pending' | 'above' | 'below';

/**
 * - `above` / `below`: the förvaltare's decision, on active and archived issues alike.
 * - `pending`: an active issue (no `archivedAt`) created at or after `enabledAt`
 *   while the setting is on with a förvaltare, still undecided.
 * - null: none of these (setting off, older issue, or archived without a decision).
 */
export const issueAssessmentState = (
    issue: Pick<Issue, 'createdAt' | 'archivedAt' | 'costAssessment'>,
    setting: IssueAutoAssignment | null | undefined
): IssueAssessmentState | null => {
    const decision = issue.costAssessment?.decision;
    if (decision === 'above' || decision === 'below') return decision;
    if (!setting || setting.enabled !== true || !setting.externalUserId || !setting.enabledAt) return null;
    if (issue.archivedAt) return null;
    // "YYYY-MM-DD hh:mm:ss" strings sort chronologically
    return issue.createdAt >= setting.enabledAt ? 'pending' : null;
};

export const ISSUE_ASSESSMENT_LABELS: Record<IssueAssessmentState, string> = {
    pending: 'Väntar på förvaltare',
    above: 'Över beloppsgräns – styrelsebeslut',
    below: 'Under beloppsgräns – tilldelad förvaltaren',
};
